import React from 'react';
import {
  BreakPointItem,
  BREAKPOINTS,
  // Visible
} from '@tfecom-thermofisher/react-komodo-design';

import { Message, Spacer, Title } from 'src/core/components';
import HPLCPurification from 'src/components/HPLCPurification';
import 'src/components/OligosForm/OligosForm.scss';

import messages from './messages';

const FormTitleComponent = () => (
  <>
    <Title message={messages.formTitle} size="3" bold />
    <Spacer bottom={8} />
    <BreakPointItem min={BREAKPOINTS.md}>
      <div className="flex-row oligos-rna">
        <div className="flex-block oligos-rna-form-title-content">
          <Message message={messages.formNote} />

          {/* <Visible when={isJapan}>
            <p>
              <Message message={messages.formInstructions} />
              <div>
                <ul>
                  <li>
                    <Message message={messages.instructionOne} />
                  </li>
                  <li>
                    <Message message={{
                      ...messages.instructionTwo,
                      values: {
                        instructionTwoContent: (
                          <>
                            <br />
                            <Message message={messages.instructionTwoContent} />

                          </>
                        )
                      }
                    }}
                    />
                  </li>
                </ul>
              </div>
            </p>
          </Visible> */}
        </div>

        <div className="oligos-rna-hplc-content">
          <HPLCPurification />
        </div>
      </div>
    </BreakPointItem>

    <BreakPointItem max={BREAKPOINTS.md}>
      <Message message={messages.formNote} />

      {/* <Visible when={isJapan}>
        <p>
          <Message message={messages.formInstructions} />
          <div>
            <ul>
              <li>
                <Message message={messages.instructionOne} />
              </li>
              <li>
                <Message message={{
                  ...messages.instructionTwo,
                  values: {
                    instructionTwoContent: (
                      <>
                        <br />
                        <Message message={messages.instructionTwoContent} />

                      </>
                    )
                  }
                }}
                />
              </li>
            </ul>
          </div>
        </p>
      </Visible> */}

      <Spacer top={8} />

      <HPLCPurification />
    </BreakPointItem>
    <Spacer bottom={8} />
  </>
);

export default FormTitleComponent;
